import appService from '../service/app.service';

export const saveSystemLog = async (data) => {
  try {
    await appService.createSystemLog(data);
  } catch (err) {
    console.error('SystemLog mentés sikertelen:', err);
  }
};
